var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6875 9.5C1.6875 5.46278 4.96278 2.1875 9 2.1875C13.0372 2.1875 16.3125 5.46278 16.3125 9.5C16.3125 13.5372 13.0372 16.8125 9 16.8125C4.96278 16.8125 1.6875 13.5372 1.6875 9.5ZM9 3.3125C5.5841 3.3125 2.8125 6.0841 2.8125 9.5C2.8125 12.9159 5.5841 15.6875 9 15.6875C12.4159 15.6875 15.1875 12.9159 15.1875 9.5C15.1875 6.0841 12.4159 3.3125 9 3.3125Z",
    fill: "#1B2436"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.22725 7.696C5.44692 7.47633 5.80308 7.47633 6.02275 7.696L9 10.6733L11.9773 7.696C12.1969 7.47633 12.5531 7.47633 12.7727 7.696C12.9924 7.91567 12.9924 8.27183 12.7727 8.4915L9.39775 11.8665C9.17808 12.0862 8.82192 12.0862 8.60225 11.8665L5.22725 8.4915C5.00758 8.27183 5.00758 7.91567 5.22725 7.696Z",
    fill: "#1B2436"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDown);
export default __webpack_public_path__ + "static/media/dropDown.a82960404d2e37b12388788cd8a25848.svg";
export { ForwardRef as ReactComponent };